import { TNavigationTreeNode } from '../redux-store';

export const SINGLE_FACTORY_GROUP_SCREEN_NAVIGATION_NODES: TNavigationTreeNode['id'][] = [
  'TICKET_SUMMARY',
  'TICKET_MANAGEMENT',
  'SUMMARY_ANALYTICS',
  'TICKET_DETAILS',
];

export const GROUP_SCREEN_NAVIGATION_NODES: TNavigationTreeNode['id'][] = [
  'EMPLOYEE_MANAGEMENT',
  'LOCATION_MANAGEMENT',
  'SPAREPART_LIST',
  'NEEDLE_LIST',
  'SPAREPART_REQUEST_LIST',
  'MACHINE_LIST',
  ...SINGLE_FACTORY_GROUP_SCREEN_NAVIGATION_NODES,
];

export const MOBILE_NODES: TNavigationTreeNode['id'][] = [
  'ASSET_MANAGEMENT',
  'NEEDLE_LIST',
  'LINE_VIEW',
  'LINE_DETAILS',
  'TICKET_SUMMARY',
  'MACHINE_LOG_VIEW',
  'TICKET_DETAILS',
  'MAINTENANCE_TICKETS',
  'CONFIG_SETUP',
  'SHIFT_MANAGEMENT',
  'SUMMARY_ANALYTICS',
  'TICKET_MANAGEMENT',
  'NPT',
  'LOG_NPT',
  'LOG_NPT_WORKSTATIONS',
  'LINE_SET_UP',
  'LINE_SETUP_TICKET_VIEW',
  'LINE_SETUP_TICKET_DETAILS',
  'LINE_SETUP_TICKET_SUBTASKS',
  'FACTORY_MANAGEMENT',
  'MECHANIC_DASHBOARD',
  'HOME',
  'APPROVALS',
  'NEEDLE_REQUEST_LIST',
  'REQUESTS',
  'LOCAL_NEEDLE_REQUESTS',
  'ATTACHMENT_APPROVAL',
];

export const NAVIGATION_TREE_LIST: TNavigationTreeNode[] = [
  {
    id: 'HOME',
    title: 'Home',
    url: ['/home'],
    featureId: 'HOME',
    hide: true,
    children: [],
  },
  {
    id: 'ASSET_MANAGEMENT',
    title: 'navigation.AssetManagement',
    title_minimizedVersion: 'navigation.Assets',
    url: ['/asset-management'],
    icon: 'assets/icon/sidebar/ic-assets.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-assets-large.svg',
    featureId: 'ASSET_MANAGEMENT',
    children: [
      {
        id: 'MACHINE_LIST',
        title: 'navigation.MachineList',
        url: ['/machine-list'],
        icon: '',
        children: [],
        featureId: 'MACHINE_VIEW',
      },
      {
        id: 'SPAREPART_LIST',
        title: 'navigation.SparePartsList',
        url: ['/sparepart-list'],
        icon: '',
        children: [],
        featureId: 'SPARE_PART_VIEW',
      },
      {
        id: 'NEEDLE_LIST',
        title: 'navigation.NeedleList',
        url: ['/needle-list'],
        icon: '',
        children: [],
        showBack: true,
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/needle-list.svg',
          text: 'navigation.NeedleList',
        },
        featureId: 'NEEDLE_VIEW',
      },
      {
        id: 'ATTACHMENT_LIST',
        title: 'navigation.AttachmentList',
        url: ['/attachment-list'],
        icon: '',
        children: [],
        showBack: true,
        backPath: '/ticket-management/summary',
        featureId: 'ATTACHMENT_VIEW',
      },
    ],
  },
  {
    id: 'CONFIG_SETUP',
    title: 'navigation.ConfigSetup',
    title_minimizedVersion: 'navigation.Config',
    url: ['/config-setup'],
    icon: 'assets/icon/sidebar/ic-config.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-config-large.svg',
    featureId: 'HOLIDAY_VIEW',
    // todo[jyotishka] - ask for config setup feature id
    children: [
      {
        id: 'HOLIDAY_LIST',
        title: 'navigation.HolidayList',
        url: ['/holiday-list'],
        icon: '',
        children: [],
        featureId: 'HOLIDAY_VIEW',
      },
      {
        id: 'MULTI_SHIFT_MANAGEMENT',
        title: 'navigation.ShiftManagement',
        url: ['/multi-shift-management'],
        icon: '',
        children: [],
        featureId: 'SHIFT_GET',
      },
      {
        id: 'SHIFT_MANAGEMENT',
        title: 'navigation.ShiftUpdates',
        url: ['/shift-management'],
        icon: '',
        children: [],
        hide: false,
        showBack: true,
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-shift-management.svg',
          text: 'navigation.ShiftManagement',
        },
        featureId: 'SHIFT_GET',
      },
    ],
  },
  {
    id: 'FACTORY_MANAGEMENT',
    title: 'navigation.FactoryManagement',
    title_minimizedVersion: 'navigation.Factory',
    url: ['/factory-management'],
    icon: 'assets/icon/sidebar/ic-factory.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-factory-large.svg',
    featureId: 'FACTORY_MANAGEMENT',
    children: [
      {
        id: 'EMPLOYEE_MANAGEMENT',
        title: 'navigation.EmployeeManagement',
        url: ['/employee-management'],
        icon: '',
        children: [],
        featureId: 'EMPLOYEE_VIEW',
      },
      {
        id: 'MECHANIC_DASHBOARD',
        title: 'navigation.MechanicDashboard',
        url: ['/mechanic-dashboard'],
        icon: '',
        children: [],
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-mechanic-dash.svg',
          text: 'Mechanic Dashboard',
        },
        featureId: 'EMPLOYEE_LOGIN_ACTIVITY_VIEW',
      },
      {
        id: 'LOCATION_MANAGEMENT',
        title: 'navigation.LocationManagement',
        url: ['/location-management'],
        icon: '',
        children: [],
        featureId: 'LOCATION_VIEW',
      },
    ],
  },
  {
    id: 'MAINTENANCE_MANAGEMENT',
    featureId: 'MAINTENANCE_MANAGEMENT',
    title: 'navigation.MaintenanceManagement',
    title_minimizedVersion: 'navigation.Maintenance',
    url: ['/maintenance-management'],
    icon: 'assets/icon/sidebar/ic-service.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-service-large.svg',
    children: [
      {
        id: 'BREAKDOWN_REASON',
        title: 'navigation.BreakdownReason',
        url: ['/breakdown-reason'],
        icon: '',
        children: [],
        featureId: 'BREAKDOWN_REASON_VIEW',
      },
      {
        id: 'MACHINE_SERVICE',
        title: 'navigation.MachineService',
        url: ['/machine-service'],
        icon: '',
        children: [],
        featureId: 'MAINTENANCE_SCHEDULE_VIEW',
      },
    ],
  },
  {
    id: 'LINE_SET_UP',
    featureId: 'LINE_SET_UP',
    title: 'navigation.LineSet-up',
    url: ['/line-set-up'],
    icon: 'assets/icon/sidebar/ic-line.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-line-large.svg',
    children: [
      {
        id: 'LINE_VIEW',
        title: 'navigation.LineOverview',
        url: ['/line-overview'],
        icon: '',
        children: [],
        showBack: true,
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-line.svg',
          text: 'navigation.LineOverview',
        },
        featureId: 'LINE_VIEW',
      },
      {
        id: 'LINE_DETAILS',
        title: 'navigation.LineDetails',
        url: ['/line-overview/:line/:department/:locationId'],
        icon: '',
        children: [],
        hide: true,
        showBack: true,
        backPath: '/line-set-up/line-overview',
        featureId: 'WORKSTATION_LIST_VIEW',
      },
      {
        id: 'LINE_SETUP_TICKET_VIEW',
        title: 'navigation.ChangeOver',
        url: ['/change-over'],
        icon: '',
        children: [],
        showBack: true,
        hasMobileSubHeader: true,
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-line.svg',
          text: 'navigation.ChangeOver',
        },
        featureId: 'LINE_SETUP_TICKET_VIEW',
      },
      {
        id: 'LINE_SETUP_TICKET_SUBTASKS',
        title: 'navigation.Subtasks',
        url: ['/change-over/subtask/:ticketId'],
        icon: '',
        children: [],
        hide: true,
        showBack: true,
        backPath: '/line-set-up/change-over',
        featureId: 'LINE_SETUP_TICKET_VIEW',
      },
      {
        id: 'LINE_SETUP_TICKET_DETAILS',
        title: 'navigation.LineDetails',
        url: ['/change-over/ticket-details/:locationId/:line/:ticketId'],
        icon: '',
        children: [],
        hide: true,
        hasMobileSubHeader: true,
        showBack: true,
        backPath: '/line-set-up/change-over',
        featureId: 'LINE_SETUP_TICKET_VIEW',
      },
    ],
  },
  {
    id: 'NPT',
    featureId: 'NPT_VIEW',
    title: 'navigation.Npt',
    url: ['/npt'],
    icon: 'assets/icon/sidebar/ic-npt.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-npt-large.svg',
    children: [
      {
        id: 'REASONS_UPLOAD_NPT',
        title: 'navigation.ReasonsUpload',
        url: ['/npt-reasons-upload'],
        icon: '',
        children: [],
        showBack: true,
        backPath: '/ticket-management/summary',
        featureId: 'NPT_REASON_VIEW',
      },
      {
        id: 'LOG_NPT',
        title: 'navigation.LogNpt',
        url: ['/log-npt'],
        icon: '',
        children: [],
        showBack: true,
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-npt.svg',
          text: 'navigation.Npt',
        },
        featureId: 'NPT_VIEW',
      },
      {
        id: 'LOG_NPT_WORKSTATIONS',
        title: 'navigation.Npt',
        url: ['/log-npt/:locationId'],
        icon: '',
        children: [],
        hide: true,
        showBack: true,
        backPath: '/npt/log-npt',
        featureId: 'NPT_VIEW',
      },
    ],
  },
  {
    id: 'TICKET_MANAGEMENT',
    featureId: 'TICKET_MANAGEMENT',
    title: 'navigation.TicketManagement',
    url: ['/ticket-management'],
    icon: 'assets/icon/sidebar/ic-ticket.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-ticket-large.svg',
    children: [
      {
        id: 'TICKET_SUMMARY',
        title: 'navigation.TicketsSummary',
        url: ['/summary'],
        icon: '',
        children: [],
        hide: false,
        isMobileLandingScreen: true,
        featureId: 'TICKET_VIEW',
      },
      {
        id: 'SUMMARY_ANALYTICS',
        title: 'navigation.SummaryAnalytics',
        url: ['/summary-analytics'],
        icon: '',
        children: [],
        hide: false,
        showBack: true,
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-summary-analytics.svg',
          text: 'navigation.SummaryAnalytics',
        },
        featureId: 'TICKET_ANALYTICS',
      },
      {
        id: 'MACHINE_LOG_VIEW',
        title: 'navigation.MachineHistory',
        url: ['/machineHistory/:factorySerialNumber'],
        icon: '',
        children: [],
        hide: true,
        showBack: true,
        backPath: '/ticket-management/summary',
        hasMobileSubHeader: true,
        featureId: 'MACHINE_LOG_VIEW',
      },
      {
        id: 'TICKET_DETAILS',
        title: 'navigation.MachineIssueTickets',
        url: ['/machine-issue-tickets'],
        icon: '',
        children: [],
        hide: false,
        showBack: true,
        backPath: '/ticket-management/summary',
        hasMobileSubHeader: true,
        featureId: 'TICKET_DETAILS',
      },
      {
        id: 'MAINTENANCE_TICKETS',
        title: 'navigation.MaintenanceTickets',
        url: ['/maintenance-tickets'],
        icon: '',
        children: [],
        hide: false,
        showBack: true,
        backPath: '/ticket-management/summary',
        hasMobileSubHeader: true,
        featureId: 'MAINTENANCE_TICKET_VIEW',
      },
    ],
  },
  {
    id: 'APPROVALS',
    title: 'navigation.Approvals',
    title_minimizedVersion: 'navigation.Approvals',
    url: ['/approvals'],
    icon: 'assets/icon/sidebar/ic-tasks.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-tasks-large.svg',
    featureId: 'APPROVALS',
    children: [
      {
        id: 'SPAREPART_REQUEST_LIST',
        title: 'navigation.SparePartRequest',
        url: ['/sparepart-request'],
        icon: '',
        children: [],
        featureId: 'SPARE_PART_REQUEST_VIEW',
      },
      {
        id: 'NEEDLE_REQUEST_LIST',
        title: 'navigation.NeedleRequest',
        url: ['/needle-request'],
        icon: '',
        children: [],
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/needle-requests.svg',
          text: 'navigation.NeedleRequest',
        },
        hasMobileSubHeader: true,
        featureId: 'NEEDLE_REQUEST_VIEW',
      },
      {
        id: 'ATTACHMENT_APPROVAL',
        title: 'navigation.AttachmentRepair',
        url: ['/attachment-repair'],
        icon: '',
        children: [],
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/ic-attachment-approval.svg',
          text: 'navigation.AttachmentRepair',
        },
        hasMobileSubHeader: true,
        featureId: 'ATTACHMENT_REPAIR_VIEW',
      },
    ],
  },
  {
    id: 'REQUESTS',
    title: 'navigation.Requests',
    title_minimizedVersion: 'navigation.Requests',
    url: ['/requests'],
    icon: 'assets/icon/sidebar/ic-tasks.svg',
    icon_minimizedVersion: 'assets/icon/sidebar/ic-tasks-large.svg',
    featureId: 'REQUESTS',
    children: [
      {
        id: 'LOCAL_NEEDLE_REQUESTS',
        title: 'navigation.Needle',
        url: ['/needle'],
        icon: '',
        children: [],
        backPath: '/ticket-management/summary',
        mobileSidebarConf: {
          icon: 'assets/icon/sidebar/raised-needle-requests.svg',
          text: 'navigation.RaisedNeedleRequest',
        },
        hasMobileSubHeader: true,
        featureId: 'LOCAL_STORE_NEEDLE_REQUEST_VIEW',
      },
    ],
  },
];
